import * as React from "react";
import { FC } from "react";
import { Layout, LayoutProps } from 'react-admin';
import Menu from './Menu';

import AppBar from './AppBar';

const MyLayout: FC<LayoutProps> = props => <Layout {...props} appBar={AppBar} menu={Menu}/>;

export default MyLayout;